var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckMark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "#515864",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M9.628 18.003c-.5 0-.975-.198-1.325-.545l-3.75-3.714a1.834 1.834 0 010-2.625 1.876 1.876 0 012.65 0l2.263 2.241 6.2-7.664a1.883 1.883 0 012.637-.284 1.84 1.84 0 01.288 2.612l-7.5 9.286a1.88 1.88 0 01-1.363.693h-.1z"
  })));
}
export default SvgCheckMark;